import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

interface BotonReintentarProps {
  onReintentar: () => void;
  /** La recarga está en curso: el botón lo dice y no acepta otro clic. */
  reintentando: boolean;
}

/**
 * Botón "Reintentar" de los estados de error.
 *
 * Refleja que la recarga está EN CURSO: sin eso, el usuario clickeaba, no
 * pasaba nada visible por un segundo y volvía a clickear — nunca sabía si el
 * pedido salió.
 */
export function BotonReintentar({ onReintentar, reintentando }: BotonReintentarProps) {
  return (
    <Button
      variant="outline"
      onClick={onReintentar}
      disabled={reintentando}
      className="gap-2"
    >
      {reintentando && <Spinner />}
      {reintentando ? "Reintentando…" : "Reintentar"}
    </Button>
  );
}
